import { lazy } from 'react';

export const VendorsMainPageAsync = lazy(() => import('./VendorsMainPage'));
